import { Button, Typography } from '@wbk/ui';
import { UpRightIcon } from '@wbk/svg';
import { WebSection } from '@wbk/contentful/api';
import { ContentfulMedia } from '@wbk/contentful';

const Recap2024 = ({ section }: { section: WebSection }) => {
  return (
    <section className='px-[3vw]'>
      <div className='relative h-[95vh] w-full overflow-hidden rounded-[40px]'>
        <svg className='absolute h-0 w-0'>
          <defs>
            <clipPath id='videoNotch' clipPathUnits='objectBoundingBox'>
              <path
                d='
          M1344 870C1344 892.091 1326.09 910 1304 910H40C17.9086 910 0 892.091 0 870V40C0 17.9086 17.9086 0 40 0H406.566C425.031 0 440 14.9689 440 33.4341C440 51.8992 454.969 66.8682 473.434 66.8682H870.566C889.031 66.8682 904 51.8992 904 33.4341C904 14.9689 918.969 0 937.434 0H1304C1326.09 0 1344 17.9086 1344 40V870Z'
                transform='scale(0.000744, 0.001099)'
              />
            </clipPath>

            <clipPath id='videoNotchMobile' clipPathUnits='objectBoundingBox'>
              <path
                d='M362 768C362 785.673 347.673 800 330 800H32C14.3269 800 0 785.673 0 768V32C0 14.3269 14.3269 0 32 0H145C151.627 0 157 5.37258 157 12V12C157 18.6274 162.373 24 169 24H193C199.627 24 205 18.6274 205 12V12C205 5.37258 210.373 0 217 0H330C347.673 0 362 14.3269 362 32V768Z'
                transform='scale(0.00277, 0.00125)'
              />
            </clipPath>
          </defs>
        </svg>

        {section.sectionBackground && (
          <ContentfulMedia
            media={section.sectionBackground}
            autoPlay
            muted
            loop
            className='h-[800px] w-full object-cover lg:h-full'
            style={{
              clipPath: window.innerWidth < 640 ? 'url(#videoNotchMobile)' : 'url(#videoNotch)',
            }}
          />
        )}
        <div className='container mx-auto 2xl:relative'>
          <div className='container-padding absolute bottom-14 left-0 flex flex-col justify-between gap-[40px] lg:flex-row lg:items-end lg:gap-[102px]'>
            <Typography className='xl:text-display-S rtl:font-expo-arabic 2xl:text-display-M font-gellix text-heading-XL text-nowrap font-extrabold uppercase leading-[1] tracking-[-0.5px] mix-blend-difference sm:text-[60px] sm:tracking-[-4px]'>
              {section.title.split(' ').slice(0, 2).join(' ')}
              <br />
              {section.title.split(' ').slice(2).join(' ')}
            </Typography>
            <div className='flex flex-col-reverse gap-4 lg:flex-col'>
              <div className='flex'>
                <Button
                  phill
                  as='a'
                  href={section.webLinksCollection?.items[0]?.href}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='flex items-center gap-2 border border-[#52525B] bg-transparent px-6 py-2 font-semibold sm:max-w-[330px] sm:px-3 md:h-[63px]'
                >
                  <Typography className='text-body-XS sm:text-body-M lg:text-body-L'>
                    {section.webLinksCollection?.items[0]?.label}
                  </Typography>
                  <UpRightIcon />{' '}
                </Button>
              </div>
              <Typography className='text-body-M max-w-[90%] lg:max-w-full'>
                {section.subtitle}
              </Typography>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Recap2024;
